<template>
    <b-card no-body>
        
            <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
                <account-pair-create-or-update v-model="pair" :errors="errors" :editing="editing"></account-pair-create-or-update>
                <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
            </b-modal>
        
            <v-table    ref="table"
                        :buttons="buttons"
                        name="bank-branch"
                        :fields="fields"
                        pagination="server"
                        search
                        :items-provider="provider"
                        :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import AccountPairCreateOrUpdate from './components/AccountPairCreateOrUpdate.vue';
import NetsisApi from '@/api/netsis-operations'

export default {
    components:{
        BCard,
        AccountPairCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:"Kasa Kodu",key:"VaultCode", thClass:"w-30",sortable:true},   
                {name:"Kasa Adı",key:"VaultName", thClass:"w-35",sortable:true},   
                {name:"Muhasebe Hesap Kodu",key:"AccountCode", thClass:"w-35",sortable:true},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            pair:{
                Id:null,
                VaultCode:null,
                AccountCode:null,
                AccountName:null,
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.pair.Id = null
            this.pair.VaultCode = null
            this.pair.VaultName = null
            this.pair.AccountCode = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return NetsisApi.AccountPair.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.pair.Id = item.Id
            this.pair.VaultCode = item.VaultCode
            this.pair.VaultName = item.VaultName
            this.pair.AccountCode = item.AccountCode
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            NetsisApi.AccountPair.CreateOrUpdate(this.editing,this.pair).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.VaultCode} - ${item.AccountCode} hesap eşleşmesini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    NetsisApi.AccountPair.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>